export default function(user) {
    if(user && user.avatarSrc) {
        return user.avatarSrc;
    } else {
        return 'images/default-avatar-user.png';
    }  
}